// Lib
import { get } from 'lodash/fp';

// Utils
import { http } from '../utils/services/http';
import { manuallyReportError } from '../analytics/rollbarService';

// Constants
import { METHODS } from '../../common/utils/http/httpConstants';
import { ROLLBAR_LEVELS } from '../analytics/rollbarConstants';

/**
 * Validates a password for a board's permission.
 */
export const validatePermissionPasswordHttp = ({ elementId, permissionId, password }) =>
    http({
        method: METHODS.POST,
        url: `elements/${elementId}/validate-password`,
        data: { password, permissionId },
    })
        .then(get('data'))
        .catch((err) => {
            manuallyReportError({
                errorMessage: 'Failed to validate published password',
                error: err,
                level: ROLLBAR_LEVELS.INFO,
                sensitive: true,
            });
            throw err;
        });

/**
 * Validates a password for a board's permission.
 */
export const validatePreviewPasswordHttp = ({ elementId, permissionId, password }) =>
    http({
        method: METHODS.POST,
        url: `elements/${elementId}/validate-preview-password`,
        data: { password, permissionId },
    })
        .then(get('data'))
        .catch((err) => {
            manuallyReportError({
                errorMessage: 'Failed to validate published password',
                error: err,
                level: ROLLBAR_LEVELS.INFO,
                sensitive: true,
            });
            throw err;
        });
